import { schemaMigrations } from "@nozbe/watermelondb/Schema/migrations";

export const offlineMigrations = schemaMigrations({
  migrations: [],
});
